export default "__VITE_ASSET__3a31e52b__"